import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import loader from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import Swal from "sweetalert2";

const InstallationProvisioningForm = () => {
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: "none",
    }),
  };

  const [InstallationModel, setInstallationModel] = useState([]);
  const [InstallationProvData, setInstallationProvData] = useState([]);
  const [venderCode, setVenderCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [getModel, setModel] = useState("");
  const [profileName, setProfileName] = useState("");

  const [userData, setUserData] = useState({
    ont: "",
    reneterOnt: "",
    profile: "",
    towerName: "",
    servingDB: "",
  });

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    setVenderCode(sessionStorage.getItem("vendorCode"));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getAccountDetails",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          VendorCode: venderCode,
          CanId: sessionStorage.getItem("provisioningCANID"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          // console.log("API Response of ProviForm:", result);
          if (
            result &&
            result.Response &&
            result.Response.Status !== "Failure"
          ) {
            setInstallationModel(result.Response.data.onuProfile);
            setInstallationProvData(result.Response.data);
            setUserData({
              ont: result.Response.data.ONTSerialNo,
              reneterOnt: result.Response.data.ONTSerialNo,
              towerName: result.Response.data
                ? result.Response.data.towerDetail[0].towerName
                : "",
              servingDB: result.Response.data
                ? result.Response.data.towerDetail[0].servingDB
                : "",
            });
            sessionStorage.setItem(
              "towerId",
              result.Response.data.towerDetail[0].towerId
            );
          } else {
            const errorMessage =
              result && result.Response && result.Response.Message;
            toast.warning(`${errorMessage}`, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } else {
          console.error("Error fetching data:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    if (venderCode) {
      fetchData();
    }
  }, [venderCode]);

  const handleModel = (selectedOption) => {
    setModel(selectedOption);
    const selectedIndex = parseInt(selectedOption.value.split("_")[1]); // Extract the index from the selected value
    const selectedModel = InstallationModel[selectedIndex]; // Find the model object based on the index
    if (selectedModel) {
      setProfileName(selectedModel.profileName); // Set the profileName based on the selected model
    } else {
      setProfileName(""); // If the selected model is not found, set profileName to empty string
    }
  };

  const handleResendONT = async () => {
    if (!userData.reneterOnt) {
      toast.warning("Please Enter ONT Serial Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestData = {
          Action: "getPowerByONT",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          ONTSerialNo: null,
          CanId: sessionStorage.getItem("provisioningCANID"),
        };
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        if (response.ok) {
          const result = await response.json();
          // console.log("API Response of getPowerByONT:", result);
          if (
            result &&
            result.Response &&
            result.Response.Status !== "Failure"
          ) {
            // console.log("getPowerByONT", result.Response);
            Swal.fire({
              title:
                "<div style='font-size: 20px;margin:0px;'>INAS Power</div>",
              html: `
              <span>Active Status : <span style='color:green;'>${result.Response.ActiveStatus} </span></span><br/>
              <span>Power level : <span style='color:#cfb12d;'>${result.Response.PowerLevel} </span></span><br/>
              <span>Alarm Details : <span style='color:#cfb12d;'>${result.Response.AlarmsInfo} </span></span><br/>
              <span>Fibre Distance : <span>${result.Response.FiberDistance} </span></span><br/>
              <span>IP Address : <span>${result.Response.IPAddress} </span></span><br/>
            `,
              showCloseButton: true,
              showConfirmButton: false,
              customClass: {
                title: "swal2-title-custom",
                closeButton: "swal2-close-button-custom",
              },
            });
          } else {
            const errorMessage =
              result && result.Response && result.Response.Message;
            toast.warning(`${errorMessage}`, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } else {
          console.error("Error fetching data:", response.status);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const submitProvisioning = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        Action: "provisioning",
        OnuSerial: userData.reneterOnt ? userData.reneterOnt : "",
        Profile: profileName,
        Description: "",
        TowerId: sessionStorage.getItem("towerId"),
        SplitterId: "",
        CanId: sessionStorage.getItem("provisioningCANID"),
        Power: "",
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      if (response.ok) {
        const result = await response.json();
        // console.log("API Response:", result);
        if (result.Status === "Success") {
          // console.log("success");
        } else {
          // Handle failure response
          console.error("Error:", result.Response.Message);
        }
      } else {
        console.error("Error fetching data:", response.status);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const navigate = useNavigate();
  const redirectProvisioningPage = () => {
    navigate("/installationprovisioning");
  };

  return (
    <>
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectProvisioningPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          <span className="p-1 m-3">Provisioning</span>
        </div>
      </div>

      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div className="container-fluid" style={{ marginTop: "65px" }}>
          <div className=" container border">
            <div className="m-2">
              <div className="row mt-1">
                <div className="col-5 text-weight-color">Can ID </div>
                <div className="col-1">:</div>
                <div className="col-6">
                  {InstallationProvData.AccountNumber}
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-5 text-weight-color">Customer Name </div>
                <div className="col-1">:</div>
                <div className="col-6">
                  {InstallationProvData.Name}
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-5 text-weight-color">City </div>
                <div className="col-1">:</div>
                <div className="col-6">
                  {InstallationProvData.City}
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-5 text-weight-color">Product Name </div>
                <div className="col-1">:</div>
                <div className="col-6">
                  {InstallationProvData.Productname}
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-5 text-weight-color">Building/Society  </div>
                <div className="col-1">:</div>
                <div className="col-6">
                  {InstallationProvData.Status}
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-5 text-weight-color">Address  </div>
                <div className="col-1">:</div>
                <div className="col-6">
                  {InstallationProvData.Address}
                </div>
              </div>
              
            </div>
            <div>
              <div className="input-box form-floating">
                <form className="lead-form">
                  <div className="input-box form-floating mt-4">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="ont"
                      name="ont"
                      value={userData.ont}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      ONT Serial Number
                    </label>
                  </div>

                  <div
                    className="input-box form-floating"
                    style={{ position: "relative" }}
                  >
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="reneterOnt"
                      name="reneterOnt"
                      value={userData.reneterOnt}
                      onChange={handleChange}
                    />
                    <button
                      type="button"
                      onClick={handleResendONT}
                      className="btn bg-dark text-light"
                      style={{
                        position: "absolute",
                        right: "1px",
                        top: "55%",
                        transform: "translateY(-50%)",
                        fontSize: "12px",
                        borderRadius: "0px",
                      }}
                    >
                      CHECK INAS
                    </button>
                    <label htmlFor="floatingInput" className=" reneterOnt">
                      Re enter ONT Serial Number
                    </label>
                  </div>

                  {/* {console.log("InstallationModel", InstallationModel)} */}
                  <div className="">
                    <label className="select-search-label mt-1">Model</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="CustContactable"
                      placeholder="Select Model Name"
                      styles={style}
                      value={getModel}
                      isSearchable={false}
                      onChange={handleModel}
                      options={InstallationModel.map((data, index) => ({
                        value: `${data.modelName}_${index}`, // Use a combination of modelName and index as a unique value
                        label: data.modelName,
                        key: index, // Add a key to each option to avoid React warnings
                      }))}
                    />
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="profile"
                      name="profile"
                      value={profileName}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Profile Name
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="towerName"
                      name="towerName"
                      value={userData.towerName}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Tower/Structure
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="servingDB"
                      name="servingDB"
                      value={userData.servingDB}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Serving Db
                    </label>
                  </div>
                </form>
              </div>
            </div>

            <div className=" text-center mt-5 mb-5">
              <button
                type="submit"
                className="btn text-light approval-btn bg-dark mx-auto rounded-pill"
                onClick={submitProvisioning}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InstallationProvisioningForm;
